import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const response = await axios.get(`${API}/bookings`);
      setBookings(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching bookings:', error);
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  if (loading) {
    return <div className="admin-loading">Loading bookings...</div>;
  }

  return (
    <div className="admin-container">
      <div className="container" style={{ paddingTop: '120px', paddingBottom: '80px' }}>
        <h1 className="heading-1" style={{ marginBottom: '40px' }}>Booking Requests</h1>
        
        {bookings.length === 0 ? (
          <p className="body-regular">No booking requests yet.</p>
        ) : (
          <div className="bookings-grid">
            {bookings.map((booking) => (
              <div key={booking.id} className="booking-card">
                <div className="booking-header-info">
                  <h3 className="heading-3">{booking.name}</h3>
                  <span className={`booking-status status-${booking.status}`}>
                    {booking.status}
                  </span>
                </div>
                
                <div className="booking-details">
                  <div className="booking-detail-item">
                    <span className="body-small" style={{ fontWeight: '600' }}>Email:</span>
                    <a href={`mailto:${booking.email}`} className="body-regular">{booking.email}</a>
                  </div>
                  
                  {booking.phone && (
                    <div className="booking-detail-item">
                      <span className="body-small" style={{ fontWeight: '600' }}>Phone:</span>
                      <a href={`tel:${booking.phone}`} className="body-regular">{booking.phone}</a>
                    </div>
                  )}
                  
                  {booking.country && (
                    <div className="booking-detail-item">
                      <span className="body-small" style={{ fontWeight: '600' }}>Country:</span>
                      <span className="body-regular">{booking.country}</span>
                    </div>
                  )}
                  
                  {booking.eventType && (
                    <div className="booking-detail-item">
                      <span className="body-small" style={{ fontWeight: '600' }}>Event Type:</span>
                      <span className="body-regular">{booking.eventType}</span>
                    </div>
                  )}
                  
                  <div className="booking-detail-item">
                    <span className="body-small" style={{ fontWeight: '600' }}>Date:</span>
                    <span className="body-small">{formatDate(booking.timestamp)}</span>
                  </div>
                  
                  <div className="booking-message">
                    <span className="body-small" style={{ fontWeight: '600' }}>Message:</span>
                    <p className="body-regular" style={{ marginTop: '8px' }}>{booking.message}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminBookings;
